import { render, staticRenderFns } from "./RawScrapeType.vue?vue&type=template&id=23db6576&"
import script from "./RawScrapeType.vue?vue&type=script&lang=js&"
export * from "./RawScrapeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports